import { systemConfigApi } from '../api/modules/systemConfig.api';
import { getApiErrorMessage } from '../api/client';
import { USE_API } from '../config/api';
import {
  SYSTEM_CONFIG_DEFS,
  getSystemConfig as getMockConfig,
  resetSystemConfig as resetMockConfig,
  updateSystemConfig as updateMockConfig,
} from '../data/system/systemConfig';
import {
  systemConfigFromApiList,
  systemConfigValueToApi,
} from '../models';

const DEFAULTS = SYSTEM_CONFIG_DEFS.reduce((acc, def) => {
  acc[def.key] = def.defaultValue;
  return acc;
}, {});

export async function getSystemConfig() {
  if (!USE_API) return { ...getMockConfig() };
  try {
    const rows = await systemConfigApi.list();
    return { ...DEFAULTS, ...systemConfigFromApiList(rows) };
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load system configuration'));
  }
}

/** Async config value for feature gates (API or mock). */
export async function getConfigValue(key) {
  const config = await getSystemConfig();
  return config[key] ?? DEFAULTS[key];
}

export async function updateSystemConfig(patch) {
  if (!USE_API) return updateMockConfig(patch);
  try {
    const entries = Object.entries(patch || {});
    await Promise.all(
      entries.map(([uiKey, value]) => {
        const { key, value: apiValue } = systemConfigValueToApi(uiKey, value);
        return systemConfigApi.update(key, apiValue);
      }),
    );
    return getSystemConfig();
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to save system configuration'));
  }
}

export async function resetSystemConfig() {
  if (!USE_API) return resetMockConfig();
  try {
    await Promise.all(
      SYSTEM_CONFIG_DEFS.map((def) => {
        const { key, value } = systemConfigValueToApi(def.key, def.defaultValue);
        return systemConfigApi.update(key, value);
      }),
    );
    return getSystemConfig();
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to reset system configuration'));
  }
}
